<script>
	export let active;
	import Template from '../components/Template.svelte';
</script>
<Template active={active}>
	<!-- Secondary Bar -->
	<aside class="secondary-bar">
	    <div class="container-fluid wrap">
	        <div class="secondary-score">
	            <div><a href="#/downloads" class="btn-text btn-text-default btn-back">Back to Dowloads</a></div>
	            <fieldset class="score-selector">
	                <input type="radio" name="tool" value="1" checked>
	                <input type="radio" name="tool" value="2">
	                <input type="radio" name="tool" value="3">
	                <input type="radio" name="tool" value="4">
	                <input type="radio" name="tool" value="5">
	            </fieldset>
	            <div></div>
	        </div>
	    </div>
	</aside>

	<article data-intervention="1">
	    <div class="container-fluid wrap big-card">
	        
	        <!-- Content Header -->
	        <header class="tools-page-header">
	            <div class="letter">
	                <!-- S -->
	                <svg class="anm-score s" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
	                    <g>
	                        <path class="path1" d="M-14988.416000,3463.617000C-14929.433000,3467.753000,-14886.152000,3484.417000,-14816.635000,3520.110000"/>
	                        <path class="path2" d="M-14838.575000,3842.549000C-14989.094000,3820.318000,-15050.515000,3743.678000,-15029.790000,3647.256000C-15014.080000,3562.946000,-14945.938000,3512.865000,-14816.633000,3524.973000" />
	                        <path class="path3" d="M290.431000,391.594000C456.248000,424.485000,528.308000,485.111000,524.175000,565.394000" />
	                        <path class="path4" d="M-14996.359000,4118.684000C-14903.612000,4123.175000,-14787.325000,4087.140000,-14782.092000,3958.268000" />
	                        <path class="path5" d="M-15234.925000,4036.832000C-15175.803000,4076.318000,-15114.325000,4114.348000,-14995.231000,4118.032000" />
	                    </g>
	                </svg>
	            </div>
	            <div>
	                <h2 class="title"><strong>Tools</strong> and Standards</h2>
	                <p class="subtitle">Survey population and health risks</p>
	            </div>
	        </header>

	        <!-- Filters -->
	        <form class="tools-filter">
	            <p class="label">Filter by:</p>
	            
	            <!-- Selector -->
	            <fieldset class="drop-selector drop-selector-outline">
	                <input type="checkbox" id="years-filter">
	                <label for="years-filter">
	                    <legend data-value="1">
	                        <span>All Years</span>
	                    </legend>
	                </label>
	                <ul class="drop-list drop-list-default">
	                    <li>
	                        <input type="radio" name="years-filter" value="1" data-label="All Years" id="years-filter-1">
	                        <label for="africa">
	                            <span>All filters</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="years-filter" value="2" data-label="2018" id="years-filter-2">
	                        <label for="years-filter-2">
	                            <span>2018</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="years-filter" value="3" data-label="2019" id="years-filter-3">
	                        <label for="years-filter-3">
	                            <span>2019</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="years-filter" value="4" data-label="2020" id="years-filter-4">
	                        <label for="years-filter-4">
	                            <span>2020</span>
	                        </label>
	                    </li>
	                </ul>
	            </fieldset>
	            
	            <!-- Selector -->
	            <fieldset class="drop-selector drop-selector-outline">
	                <input type="checkbox" id="authors-filter">
	                <label for="authors-filter">
	                    <legend data-value="1">
	                        <span>All Authors</span>
	                    </legend>
	                </label>
	                <ul class="drop-list drop-list-default">
	                    <li>
	                        <input type="radio" name="authors-filter" value="1" data-label="All Authors" id="authors-filter-1">
	                        <label for="authors-filter-1">
	                            <span>All Authors</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="authors-filter" value="2" data-label="Authors 1" id="authors-filter-2">
	                        <label for="authors-filter-2">
	                            <span>Authors 1</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="authors-filter" value="3" data-label="Authors 2" id="authors-filter-3">
	                        <label for="authors-filter-3">
	                            <span>Authors 2</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="authors-filter" value="4" data-label="Authors 3" id="authors-filter-4">
	                        <label for="authors-filter-4">
	                            <span>Authors 3</span>
	                        </label>
	                    </li>
	                </ul>
	            </fieldset>
	            
	            <!-- Selector -->
	            <fieldset class="drop-selector drop-selector-outline">
	                <input type="checkbox" id="key-filter">
	                <label for="key-filter">
	                    <legend data-value="1">
	                        <span>All keys</span>
	                    </legend>
	                </label>
	                <ul class="drop-list drop-list-default">
	                    <li>
	                        <input type="radio" name="key-filter" value="1" data-label="All keys" id="key-filter-1">
	                        <label for="key-filter-1">
	                            <span>All keys</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="key-filter" value="2" data-label="Key 1" id="key-filter-2">
	                        <label for="key-filter-2">
	                            <span>Key 1</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="key-filter" value="3" data-label="Key 2" id="key-filter-3">
	                        <label for="key-filter-3">
	                            <span>Key 2</span>
	                        </label>
	                    </li>
	                    <li>
	                        <input type="radio" name="key-filter" value="4" data-label="Key 3" id="key-filter-4">
	                        <label for="key-filter-4">
	                            <span>Key 3</span>
	                        </label>
	                    </li>
	                </ul>
	            </fieldset>

	            <div class="search">
	                <input type="text" placeholder="Enter your search terms">
	                <span></span>
	                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.7 20.7">
	                    <circle cx="9.5" cy="9.5" r="8.5"/>
	                    <line x1="15.9" y1="15.9" x2="19.7" y2="19.7"/>
	                </svg>
	            </div>

	            <div class="tools-filter-buttons">
	                <button class="btn btn-default">Apply</button>
	                <button class="btn btn-default" type="reset" disabled>Reset</button>
	            </div>

	        </form>

	        <!-- Resources -->
	        <section class="resources-group">
	            <div class="resources-group-details" data-intervention="1">
	                <h4 class="subtitle">Key element 1</h4>
	                <h3 class="title">System of regular population-based health surveys</h3>
	            </div>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">
	                    <figure class="thumbnail">
	                        <img alt="" src="./uploads/cover.png">
	                    </figure>

	                    <div class="items">
	                        <p class="generic-label">Full birth and death registration</p>
	                        <p class="title">Noncommunicable Diseases (NCD) Mobile Phone Survey</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">Bloomberg Philanthropies Data for Health initiative</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">2017</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The Multiple Indicator Cluster Survey (MICS) is an international household survey programme developed and supported by UNICEF. Implemented through collaboration between UNICEF, country ministries of health and statistics offices, MICS is designed to collect estimates of key indicators that can be used to assess the situation of children and women, including on child protection and early childhood education. MICS also acts as a major source of data on child health and nutrition. Topics recently developed for MICS6 include: rapid water-quality testing, social transfers, foundational learning skills (children aged 7–14), child and adult functioning, migration status, use of clean fuels and technology, and victimization. MICS PLUS follows a standard MICS survey by continuing to collect information via mobile phones, accumulating longitudinal data which can be rapidly analysed and disseminated.</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                    <div class="downloads">
	                        <p class="generic-label">Internal resources</p>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(31kb)">MICS Appendix A Budget Calculations Template.xls</a>
	                    </div>
	                </section>
	            </article>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">
	                    <figure class="thumbnail">
	                        <img alt="" src="./uploads/cover.png">
	                    </figure>

	                    <div class="items">
	                        <p class="generic-label">System of regular population-based health surveys</p>
	                        <p class="title">STEPwise approach to noncommunicable disease risk factor surveillance (STEPS)</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">WHO</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">2017</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The WHO STEPwise approach to Surveillance (STEPS) is a simple, standardized method for collecting, analysing and disseminating data on risk factors for noncommunicable diseases. The approach encourages the collection of small amounts of useful information on a regular and continuing basis. The STEPS Instrument covers three different levels or “steps” of risk factor assessment: Step 1: Questionnaire; Step 2: Physical measurements; and Step 3: Biochemical measurements.</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                    <div class="downloads">
	                        <p class="generic-label">Internal resources</p>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(276kb)">STEPS Instrument.pdf</a>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(5.58MB)">STEPS Manual.pdf</a>
	                    </div>
	                </section>
	            </article>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">
	                    <figure class="thumbnail">
	                        <img alt="" src="./uploads/cover.png">
	                    </figure>

	                    <div class="items">
	                        <p class="generic-label">Routine facility reporting system with patient and community monitoring</p>
	                        <p class="title">International Household Survey Network (IHSN) resources</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">IHSN</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">Various</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The IHSN’s mission is to improve the availability, accessibility, and quality of survey data within developing countries, and to encourage the analysis and use of this data by national and international development decision-makers, the research community, and other stakeholders</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                </section>
	            </article>
	        </section>

	        <!-- Resources -->
	        <section class="resources-group">
	            <div class="resources-group-details" data-intervention="1">
	                <h4 class="subtitle">Key element 2</h4>
	                <h3 class="title">Surveillance of public health threats</h3>
	            </div>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">
	                    <figure class="thumbnail">
	                        <img alt="" src="./uploads/cover.png">
	                    </figure>

	                    <div class="items">
	                        <p class="generic-label">Full birth and death registration</p>
	                        <p class="title">Noncommunicable Diseases (NCD) Mobile Phone Survey</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">Bloomberg Philanthropies Data for Health initiative</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">2017</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The Multiple Indicator Cluster Survey (MICS) is an international household survey programme developed and supported by UNICEF. Implemented through collaboration between UNICEF, country ministries of health and statistics offices, MICS is designed to collect estimates of key indicators that can be used to assess the situation of children and women, including on child protection and early childhood education. MICS also acts as a major source of data on child health and nutrition. Topics recently developed for MICS6 include: rapid water-quality testing, social transfers, foundational learning skills (children aged 7–14), child and adult functioning, migration status, use of clean fuels and technology, and victimization. MICS PLUS follows a standard MICS survey by continuing to collect information via mobile phones, accumulating longitudinal data which can be rapidly analysed and disseminated.</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                    <div class="downloads">
	                        <p class="generic-label">Internal resources</p>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(31kb)">MICS Appendix A Budget Calculations Template.xls</a>
	                    </div>
	                </section>
	            </article>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">

	                    <div class="items">
	                        <p class="generic-label">System of regular population-based health surveys</p>
	                        <p class="title">STEPwise approach to noncommunicable disease risk factor surveillance (STEPS)</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">WHO</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">2017</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The WHO STEPwise approach to Surveillance (STEPS) is a simple, standardized method for collecting, analysing and disseminating data on risk factors for noncommunicable diseases. The approach encourages the collection of small amounts of useful information on a regular and continuing basis. The STEPS Instrument covers three different levels or “steps” of risk factor assessment: Step 1: Questionnaire; Step 2: Physical measurements; and Step 3: Biochemical measurements.</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                    <div class="downloads">
	                        <p class="generic-label">Internal resources</p>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(276kb)">STEPS Instrument.pdf</a>
	                        <a href="#/" class="btn-text btn-text-default btn-download" data-file="(5.58MB)">STEPS Manual.pdf</a>
	                    </div>
	                </section>
	            </article>

	            <article class="resource" data-intervention="1">
	                <section class="synthesis">
	                    <figure class="thumbnail">
	                        <img alt="" src="./uploads/cover.png">
	                    </figure>

	                    <div class="items">
	                        <p class="generic-label">Routine facility reporting system with patient and community monitoring</p>
	                        <p class="title">International Household Survey Network (IHSN) resources</p>
	                        <p class="generic-label">authors</p>
	                        <p class="subtitle">IHSN</p>
	                        <p class="generic-label">year</p>
	                        <p class="subtitle">Various</p>
	                    </div>
	                </section>

	                <section class="description">
	                    <p>The IHSN’s mission is to improve the availability, accessibility, and quality of survey data within developing countries, and to encourage the analysis and use of this data by national and international development decision-makers, the research community, and other stakeholders</p>
	                </section>

	                <section class="links">
	                    <a href="#/" class="btn btn-default">Visit the external resource</a>
	                </section>
	            </article>
	        </section>
	    </div>
	</article>
</Template>